import React, { useEffect, useState } from 'react'
import { Row, Col } from 'antd';
import AOS from 'aos';
import 'aos/dist/aos.css'; // AOS styles
import Img1 from '../images/mention-001.png'
import Img2 from '../images/ring.png'
import Ringtheme from '../components/Ringsec';
import Formsec from '../components/Form';

function Engagement() {
    const [loading, setLoading] = useState(true)
    const [content, setContent] = useState(null)
    const fetchContent = async () => {
        setLoading(true)
        const response = await fetch('/api/cms/engagement/fetch', {
            method: 'POST'
        })
        const result = await response.json()
        setContent(result.content)
        setLoading(false)
    }
    useEffect(() => {
        fetchContent()
        AOS.init({
            duration: 1000, // Animation duration
            once: true,     // Whether animation should happen only once
        });
    }, []);
    return (
        <div>
            <div className="dropation">
                <div className="container">
                    <Row>
                        <Col span={24}>
                            <div className="main-engement" data-aos="fade-left">
                                <h2>{content?.banner?.title}</h2>
                                <p>{content?.banner?.paragraph}</p>
                                {/* <button>{content?.banner?.button}</button> */}
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
            <section className="section-tow">
                <div className="container">
                    <Row
                        gutter={[30, 0]}
                        align="middle"     // Vertically aligns content in the middle
                        justify="center"   // Horizontally centers the content
                    >
                        <Col span={24} data-aos="fade-bottom">
                            <h2 className='trophy' >{content?.section2?.title}</h2>
                        </Col>

                        <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                        >

                            <div className="main-troter" data-aos="fade-right">

                                <img src={content?.section2?.image} alt="img" />
                            </div>
                        </Col>


                        <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                        >
                            <div className="intro-mention-text" data-aos="fade-left">
                                <div className="main-verter">
                                    <h2>{content?.section2?.cardTitle}</h2>
                                    <p>{content?.section2?.description}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
            <Ringtheme />
            <section className="section-tow">
                <div className="container">
                    <Row
                        gutter={[30, 0]}
                        align="middle"     // Vertically aligns content in the middle
                        justify="center"   // Horizontally centers the content
                    >





                        <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                        >
                            <div className="intro-mention-text" data-aos="fade-left">
                                <div className="main-verter">
                                    <h2>{content?.section3?.title}</h2>
                                    {content?.section3?.description.map((item, ind) => <p key={ind}>{item}</p>)}
                                </div>
                            </div>
                        </Col>
                        <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                        >

                            <div className="main-troter" data-aos="fade-right">

                                <img src={content?.section3?.image} alt="img" />
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
            <Formsec />
        </div>
    )
}

export default Engagement
